// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fd9ad18d","732":"0406a391","977":"c30aac87"}[chunkId] + ".chunk.js";
};